import * as React from 'react';
import CheckboxDropdown from '@emorg-prd/standard-react/components/CheckboxDropdown';
import { Checkbox } from '../form-controls/Checkbox';
import './CheckboxFilter.css';

export type CheckboxOption = { label: string; value: string, checked: boolean };

interface CheckboxFilterProps {
	label?: string;
	buttonProps?: { size?: 'small' | 'large' };
	onChange: (event: any) => void;
	options: CheckboxOption[];
	allDefaultChecked?: boolean;
}

interface CheckboxFilterState {
	allChecked: boolean;
}

export default class CheckboxFilter extends React.Component<CheckboxFilterProps, CheckboxFilterState> {
	constructor(props) {
		super(props);
		this.state = {
			allChecked: this.props.allDefaultChecked,
		};
	}

	setAllCheckbox = (newChecked: boolean) => {
		const fakeEvent = { target: { value: 'All', checked: newChecked } };
		this.setState((prevState) => {
			return { allChecked: !prevState.allChecked };
		}, () => {
			this.props.onChange(fakeEvent);
		});
	};

	isAllChecked = () => {
		return this.state.allChecked;
	}

	handleCheckboxClick = (value: string, newChecked: boolean) => {
		const fakeEvent = { target: { value, checked: newChecked } };
		this.props.onChange(fakeEvent);

		let checkedOptions = this.props.options.filter(o => o.checked);
		let totalOptions = this.props.options.length;

		this.setState({ allChecked: checkedOptions.length === totalOptions });
	};

	render() {
		const sizeClass = this.props.buttonProps?.size === 'large' ? 'em-c-btn--large' : 'em-c-btn--small';
		return (
			<div className={this.isAllChecked() ? '' : 'custom-checkboxFilter-selected'}>
				<CheckboxDropdown
					dropdownLabel={this.props.label}
					size={sizeClass}
				>
				<Checkbox
					inline
					label="All"
					value="All"
					checked={this.state.allChecked}
					onChange={(newChecked) => this.setAllCheckbox(newChecked)}
				/>
				{this.props.options?.map((option) => (
					<Checkbox
						inline
						key={option.value}
						label={option.label}
						value={option.value}
						checked={option.checked}
						onChange={(newChecked) => this.handleCheckboxClick(option.value, newChecked)}
					/>
				))}
			</CheckboxDropdown>
			</div>
		);
	}
}